import { useEffect, useState } from "react";

const LabelConSin = ({ periodoPrueba }) => {
    const [showLabel, setShowLabel] = useState(true);
    const [text, setText] = useState(periodoPrueba);

    useEffect(() => {
        // Trigger fade out
        setShowLabel(false);

        // After fade out duration, switch text and fade in
        const timeout = setTimeout(() => {
            setText(periodoPrueba);
            setShowLabel(true);
        }, 300); // match fadeOut duration

        return () => clearTimeout(timeout);
    }, [periodoPrueba]);

    return (
        <>
            <style>
                {`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes fadeOut {
                    from { opacity: 1; transform: translateY(0); }
                    to { opacity: 0; transform: translateY(10px); }
                }
                `}
            </style>

            <label
                className="block text-[#0F3457] font-semibold mb-2"
                htmlFor="diasPeriodoPrueba"
                style={{
                    animation: `${showLabel ? "fadeIn" : "fadeOut"} 0.3s ease-in-out`,
                }}
            >
                {text ? "Con" : "Sin"} Días Periodo Prueba
            </label>
        </>
    );
};

export default LabelConSin;
